import React, { useCallback, useRef } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import CareersComponent from "salad/CareersComponent";
import CareerUploadForm from "salad/CareerUploadForm";
import GrainFooter from "salad/GrainFooter";

export default () => {
    const uploadRef = useRef(null);

    const handleUploadClick = useCallback(() => {
        if (uploadRef.current) {
            uploadRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, []);

    return (
        <div style={{ backgroundColor: "#FAB600", minHeight: "100vh" }}>
            <MobileHeaderOnly headerBg="#FAB600" drawerBg="#FAB600" />
            <AnimationRevealPage>
                <CareersComponent onUploadClick={handleUploadClick} />
                <CareerUploadForm ref={uploadRef} />
                <GrainFooter />
            </AnimationRevealPage>
        </div>
    );
};
